import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PensionReservePreviewComponent} from './pension-reserve-preview.component';
import {CommonPipesModule} from '../../../../../lifeislife-front/src/app/commons/pipes/common-pipes.module';


@NgModule({
  declarations: [PensionReservePreviewComponent],
  exports: [PensionReservePreviewComponent],
  imports: [
    CommonModule,
    CommonPipesModule,
  ],
})
export class PensionReservePreviewModule {
}
